<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="filteredEvents"
      :chart-value-keys="[ { key: variableKey, type: 'area', label: $t(`variables.${variableKey}.long`) }]"
      x-value="start_at"
      y-value-prefix="player_stats."
      :colors="['#008FFB']"
      :fill="{ type: ['gradient'], opacity: [1], gradient: { inverseColors: false, shade: 'light', type: 'vertical', opacityFrom: 0.55, opacityTo: 0.25 } }"
      :annotations="annotations"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ title }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ title }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="tableData"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.title="{ item }">
          <div style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
            {{ item.title }}
          </div>
          <div class="text-caption text-grey">
            {{ $dayjs(item.start_at).format('ddd, ll HH:mm:ss') }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'PerformanceTrendChart',
  components: { LineChart, VisualListToggle },
  props: {
    events: {
      type: Array,
      required: true
    },
    variableKey: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    annotations: {
      type: Object,
      default: () => ({})
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    filteredEvents() {
      return this.events.filter(event => {
        if (event.player_stats === null || Array.isArray(event.player_stats)) return false

        return event.player_stats[this.variableKey] !== null && event.player_stats[this.variableKey] !== undefined
      }).sort((a, b) => this.$dayjs(a.start_at) - this.$dayjs(b.start_at))
    },
    tableData() {
      return this.filteredEvents.map(event => ({
        title: event.title,
        start_at: event.start_at,
        value: event.player_stats[this.variableKey]
      }))
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.date'),
          value: 'title',
          sortable: true,
          width: '40%'
        },
        {
          text: this.title || this.variableKey,
          value: 'value',
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
